import { useQuery } from '@tanstack/react-query';
import { aivaApi } from 'src/services';

export type UseGetCallAudioParams = {
  callId: string;
};

export type GetCallAudioResponse = {
  url: string | null;
};

type UseGetCallAudioOptions = {
  enabled?: boolean;
};

export const useGetCallAudio = (
  params: UseGetCallAudioParams,
  options?: UseGetCallAudioOptions
) => {
  const { callId } = params;
  return useQuery({
    queryKey: ['callAudio', params],
    queryFn: () =>
      aivaApi
        .get<GetCallAudioResponse>(`/call/${callId}/audio`)
        .then((res) => res.data)
        .catch((err) => {
          if (err.response?.status === 404) {
            return { url: null };
          }
          throw err;
        }),
    enabled: !!callId,
    refetchOnWindowFocus: false,
    ...options,
  });
};
